const patterns: Record<string, RegExp> = {
  removeSpaces: /\s+/g,
  removeSpacesAndDashes: /[\s-]+/g,
  onlyDigits: /\D+/g,
};

/**
 * Options for trimming and cleaning input value on blur.
 *
 * - `"trim"` — performs a simple `.trim()` to remove leading and trailing whitespace
 * - `"removeSpaces"` — removes all spaces from the entire string
 * - `"removeSpacesAndDashes"` — removes all spaces and hyphens
 * - `"onlyDigits"` — keeps only numeric characters (removes everything else)
 * - `RegExp` — custom regular expression pattern for advanced cleaning
 */
export type CleanValueOption =
  | RegExp
  | boolean
  | 'onlyDigits'
  | 'removeSpaces'
  | 'removeSpacesAndDashes'
  | 'trim';

export const cleanValue = (value: string, trimOption?: CleanValueOption) => {
  if (!trimOption) {
    return value;
  }

  if (trimOption === true || trimOption === 'trim') {
    return value.trim();
  }

  if (typeof trimOption === 'string' && patterns?.[trimOption]) {
    return value.replace(patterns[trimOption], '');
  }

  if (trimOption instanceof RegExp) {
    return value.replace(trimOption, '');
  }

  return value;
};
